import { useState, useEffect, useRef } from "react";
import "./FieldToast.css";

const FieldToast = ({ message, targetRef, show, duration = 3000 }) => {
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const toastRef = useRef(null);

  useEffect(() => {
    if (show && targetRef?.current) {
      const targetRect = targetRef.current.getBoundingClientRect();
      const toastRect = toastRef.current?.getBoundingClientRect();

      if (toastRect) {
        setPosition({
          top: targetRect.top - toastRect.height - 8,
          left: targetRect.left + (targetRect.width - toastRect.width) / 2,
        });
      }
    }
  }, [show, targetRef]);

  useEffect(() => {
    if (show && duration > 0) {
      const timer = setTimeout(() => {
        // Parent component will handle hiding
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [show, duration]);

  if (!show) return null;

  return (
    <div
      ref={toastRef}
      className="field-toast"
      style={{
        position: "fixed",
        top: `${position.top}px`,
        left: `${position.left}px`,
        zIndex: 9999,
      }}
    >
      <div className="field-toast-content">
        <span className="field-toast-icon">⚠️</span>
        <span className="field-toast-message">{message}</span>
      </div>
      <div className="field-toast-arrow" />
    </div>
  );
};

export default FieldToast;
